document.addEventListener("rebuy:smartcart.ready", () => {
  // Enable add to cart submit buttons
  const addToCartSubmitButtons = document.querySelectorAll("[name='add']");
  addToCartSubmitButtons?.forEach((button) => {
    button.removeAttribute("disabled");
  });

  // Enable cart icon bubble buttons
  const cartIconsArr = document.querySelectorAll(".cart-icon-bubble__button");
  cartIconsArr?.forEach((cartIcon) => {
    cartIcon.addEventListener("click", () => Rebuy.SmartCart.show());
  });
});

// don't display cart count when there are no items in cart
document.addEventListener("rebuy:smartcart.show", (event) => {
  const allCartCounts = document.querySelectorAll(".cart-count");

  if (event.detail.smartcart.cart.item_count == 0) {
    return allCartCounts.forEach((element) => (element.textContent = ""));
  }

  allCartCounts.forEach(
    (element) => (element.textContent = Rebuy.Cart.itemCount())
  );
});
